"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CallUtils_1 = require("./CallUtils");
const CallStyles_1 = require("./CallStyles");
class PhoneCall extends React.Component {
    constructor(props) {
        super(props);
        this.callStyles = new CallStyles_1.CallStyles();
        this.state = {
            agentNumber: undefined,
            shouldShowPhoneUi: false,
            isCalling: false
        };
        this.callCustomer = this.callCustomer.bind(this);
        this.cancel = this.cancel.bind(this);
        this.updateAgentNumber = this.updateAgentNumber.bind(this);
    }
    componentDidMount() {
        let x = document.createElement("link");
        x.rel = "stylesheet";
        x.href = "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
        document.head.append(x);
        document.addEventListener(CallUtils_1.CallUtils.CALL_USER_EVENT, () => {
            this.setState({ shouldShowPhoneUi: true }, () => {
                console.log("Calling: ", sessionStorage.getItem("__userId__"));
            });
        });
    }
    updateAgentNumber(e) {
        this.setState({ agentNumber: e.target.value });
    }
    cancel() {
        this.setState({ shouldShowPhoneUi: false });
        sessionStorage.removeItem("__userId__");
        sessionStorage.removeItem('__receiverPhoneNumber__');
    }
    callCustomer() {
        const { Authorization, url, campaignId, creativeIds } = this.props.rangoonParams;
        const userId = sessionStorage.getItem("__userId__");
        const receiverPhoneNumber = sessionStorage.getItem("__receiverPhoneNumber__");
        const paramsMeta = JSON.parse(sessionStorage.getItem("__paramsMeta__")) || {};
        if (!userId && !receiverPhoneNumber) {
            this.props.onCallFail("Please enter userId.");
            return;
        }
        else if (!this.state.agentNumber) {
            this.props.onCallFail("Please Enter your phone number.");
            return;
        }
        const callParam = receiverPhoneNumber ? { phone: receiverPhoneNumber } : { userId: userId };
        const requestParams = {
            method: "POST",
            headers: {
                Authorization,
                "Content-type": "application/json"
            },
            body: JSON.stringify({
                campaignId,
                creativeIds,
                userContexts: [
                    Object.assign(Object.assign({}, callParam), { tags: Object.assign({ agentNumber: this.state.agentNumber }, paramsMeta) })
                ]
            })
        };
        fetch(url, requestParams)
            .then(res => res.text())
            .then(resText => {
            if (typeof (this.props.onCallFail) === "function") {
                this.props.onCallSuccess(JSON.parse(resText));
            }
            this.cancel();
        })
            .catch(err => {
            if (typeof (this.props.onCallFail) === "function") {
                this.props.onCallFail(err);
            }
            this.cancel();
        });
    }
    componentWillUnmount() {
        sessionStorage.removeItem("__userId__");
        sessionStorage.removeItem('__receiverPhoneNumber__');
    }
    render() {
        const { userDisplayImageUrl } = this.props;
        const { agentNumber, shouldShowPhoneUi, isCalling } = this.state;
        return (React.createElement("div", { id: "phone-call", style: Object.assign(Object.assign({}, this.callStyles.containerStyles), { zIndex: 99, display: shouldShowPhoneUi ? "block" : "none" }) },
            !userDisplayImageUrl &&
                React.createElement("div", { style: this.callStyles.displayImageStyles },
                    React.createElement("i", { className: "fa fa-user-o", "aria-hidden": "true", style: this.callStyles.userIconStyles })),
            userDisplayImageUrl &&
                React.createElement("div", null),
            React.createElement("div", { style: { textAlign: "center", padding: "5px" } },
                React.createElement("input", { style: this.callStyles.inputFieldStyles, type: "number", onChange: this.updateAgentNumber, value: agentNumber, placeholder: "Your Number" })),
            React.createElement("div", { style: { textAlign: "center", padding: "5px" } },
                React.createElement("button", { style: this.callStyles.callButtonStyles, onClick: this.callCustomer, disabled: isCalling },
                    React.createElement("i", { className: "fa fa-phone", "aria-hidden": "true" })),
                React.createElement("button", { style: this.callStyles.cancelButtonStyles, disabled: isCalling, onClick: this.cancel },
                    React.createElement("i", { className: "fa fa-close", "aria-hidden": "true" })))));
    }
}
exports.PhoneCall = PhoneCall;
